module.exports = __webpack_public_path__ + "static/Osmonaliev-Zhanarbek-CV-4daea8e662ee2430f4cb65236adb3470.pdf";